// @ts-nocheck

import { createIcon } from "@download/blockies";

export default function (id = "UXUY") {
    const canvas = createIcon({
        seed: String(id).toLowerCase(),
        size: 10, // width/height of the icon in blocks, default: 10
    });
    const dataUrl = canvas.toDataURL();

    return dataUrl;
}
